exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div#modal-inspeccion{width:100%}div#modal-img{transition:opacity .2s ease;position:fixed;z-index:9998;top:0;left:0;width:100%;min-height:100%;height:100vh;background-color:rgba(0,0,0,.8);display:table;border-color:rgba(0,0,0,.8)}*,:after,:before{box-sizing:border-box}button#close{background:transparent;font-size:25px;margin-top:0}img.rounded.img-fluid{max-width:100%;height:450px;max-height:100%;margin-bottom:.5rem;min-height:auto}", ""]);

// exports
